import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import logo from '../assets/logo.png'

const NotFoundPage = ({ context }) => {
    const navigate = useNavigate()
    const location = useLocation()

    const backPath  = '/companies'
    const backLabel = 'Voltar para Empresas'
    const backIcon  = 'business'

    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-4 relative overflow-hidden" style={{ backgroundColor: '#0A1C28' }}>
            {/* Background blobs */}
            <div className="absolute top-0 -left-40 w-96 h-96 rounded-full filter blur-3xl opacity-10 animate-pulse" style={{ backgroundColor: '#25C6A4' }} />
            <div className="absolute bottom-0 -right-40 w-96 h-96 rounded-full filter blur-3xl opacity-10 animate-pulse" style={{ backgroundColor: '#25C6A4', animationDelay: '2s' }} />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full filter blur-3xl opacity-5 animate-pulse" style={{ backgroundColor: '#25C6A4', animationDelay: '4s' }} />

            <div className="relative z-10 flex flex-col items-center text-center max-w-md w-full">
                {/* Logo */}
                <div className="logo-spin-border inline-flex items-center justify-center shrink-0 mb-6">
                    <img src={logo} alt="app" className="w-20 h-20 object-contain rounded-full" />
                </div>

                {/* Brand */}
                <h1 className="text-3xl mb-1" style={{ fontFamily: 'Blare, sans-serif', color: '#FFFFFF' }}>
                    Solid<span style={{ color: '#25C6A4' }}>.</span>Flow
                </h1>
                <p className="text-sm mb-10" style={{ fontFamily: "'Stolzl', sans-serif", color: 'rgba(255,255,255,0.5)' }}>
                    Hub de Integrações
                </p>

                {/* 404 number */}
                <p className="text-9xl font-black leading-none select-none mb-3" style={{ color: 'rgba(37,198,164,0.15)', letterSpacing: '-4px' }}>
                    404
                </p>

                {/* Card */}
                <div
                    className="w-full rounded-2xl p-8 backdrop-blur-2xl"
                    style={{
                        backgroundColor: 'rgba(10,28,40,0.85)',
                        border: '1px solid rgba(37,198,164,0.2)',
                        boxShadow: '0 0 40px rgba(37,198,164,0.08)'
                    }}
                >
                    <h2 className="text-xl font-semibold text-white mb-3">Página não encontrada</h2>

                    <div
                        className="flex items-center justify-center gap-2 mb-4 px-4 py-2 rounded-lg"
                        style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(37,198,164,0.15)' }}
                    >
                        <span className="material-icons" style={{ fontSize: 15, color: 'rgba(37,198,164,0.6)' }}>link_off</span>
                        <code className="text-xs font-mono" style={{ color: 'rgba(255,255,255,0.4)' }}>
                            {location.pathname}
                        </code>
                    </div>

                    <p className="text-sm mb-6" style={{ color: 'rgba(255,255,255,0.4)' }}>
                        Este endereço não existe ou foi removido.
                    </p>

                    <button
                        onClick={() => navigate(backPath)}
                        className="w-full flex items-center justify-center gap-2 py-3 text-white font-medium rounded-lg transition-all duration-200 transform hover:scale-[1.02]"
                        style={{ background: 'linear-gradient(135deg, #25C6A4, #1aa085)', boxShadow: '0 4px 20px rgba(37,198,164,0.3)' }}
                        onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 28px rgba(37,198,164,0.5)' }}
                        onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 4px 20px rgba(37,198,164,0.3)' }}
                    >
                        <span className="material-icons" style={{ fontSize: 18 }}>{backIcon}</span>
                        {backLabel}
                    </button>
                </div>

                <p className="text-xs mt-6" style={{ color: 'rgba(255,255,255,0.2)' }}>
                    Powered by <span style={{ fontFamily: 'Blare, sans-serif', color: 'rgba(255,255,255,0.4)' }}>Solid<span style={{ color: '#25C6A4' }}>.</span>Flow</span>
                </p>
            </div>
        </div>
    )
}

export default NotFoundPage
